import { variantCodeValues } from "src/state/production-price-list/state-models/production-price-condition";
import { ProductionPriceList } from "src/state/production-price-list/state-models/production-price-list";

export interface PriceListForm {
    id?: number;
    description: string;
    variantCombination: variantCodeValues[];
    priceType: PriceType[];
    validFrom: string;
    validTo: string;
    priceListTypeId: number;
}

export interface PriceType{
    id: number;
    name: string;
    priceValue?: number;
    validFrom?: string;
    validTo?: string;
}


export interface PriceListFormData{
    selectedRow: PriceListForm | null;
    selectedPriceListTypeId: number;
    selectedPriceList: ProductionPriceList;
}

export type PriceListFormResult = 'submitted' | 'cancelled';

